module.exports = __webpack_public_path__ + "static/media/bulle_discovery_EN_3.04356e5a.png";